<template>
  <v-row>
    <v-col cols="12" class="align-baseline">
      <div v-if="Project.fetched && !projects.length">
        <v-card-title class="py-0 title font-weight-bold letter-spacing-normal">
          No projects available. {{ !currentUser.isTourist() ? 'Please' : '' }}
          <router-link
            v-if="!currentUser.isTourist()"
            class="px-2"
            to="/projects/create"
          >
            create one
          </router-link>
          {{ !currentUser.isTourist() ? 'to proceed.' : '' }}
        </v-card-title>
      </div>

      <div
        id="project-selector"
        class="position-relative project-autocomplete"
        v-else
        ref="container"
      >
        <v-autocomplete
          v-model="project_id"
          :items="projects"
          item-text="name"
          item-value="id"
          hide-no-data
          solo
          label="Select Project"
          dense
          attach="#project-selector"
          :multiple="false"
          :hide-selected="false"
          :loading="Project.fetching"
          class="font-weight-bold"
          :filled="true"
          color="black"
          :close-on-select="true"
        >
          <template v-slot:item="{ item }">
            <template>
              <v-list-item-avatar>
                <v-img
                  :src="getMedia(item)"
                  lazy-src="/placeholder.jpg"
                  aspect-ratio="1.7"
                  class="fill-height"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.description.excerpt(100, '...')"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Project from '@models/Project';

export default {
  name: 'ProjectSlider',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    group: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      project_id: this.value,
      requiresUpdate: true,
      syncedWithProjectID: false,
      projects: [],
      Project: new Project({
        itemsPerPage: 10,
        tourism_operator_id: this.group.tourism_operator_id || null,
        filters: {
          graduated: false,
        },
        sortBy: ['contribution'],
      }),
    };
  },
  watch: {
    async project_id(projectID) {
      this.requiresUpdate = false;
      this.$emit('input', projectID);
    },
    value(value) {
      if (!this.requiresUpdate) {
        this.requiresUpdate = true;
        return;
      }
      this.project_id = value;
    },
  },
  methods: {
    async fetchProjects() {
      let isFetchingFirstTime = !this.Project.fetched;
      let response = await this.Project.get();
      if (response) {
        this.projects = response.data;
        if (isFetchingFirstTime && this.projects.length) {
          if (!this.project_id) {
            this.project_id = this.projects[0].id;
          }
        }
      }
    },
  },
  mounted() {
    this.fetchProjects();
  },
};
</script>

<style lang="scss">
.project-autocomplete {
  height: min-content;

  .v-menu__content {
    z-index: +9999999999;
    //display: contents;
    //
    //.v-list-item {
    //  border: 1px solid ghostwhite;
    //  cursor: pointer;
    //}

    .v-list {
      padding: 0;

      .v-list-item {
        border: 1px solid #ccc;

        &:not(:last-child) {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
